import ServiceCRUD from '../../../../services/ServiceGasOrder';

class SubReasonService extends ServiceCRUD {
  constructor() {
    super('/api/submotivos');
  }
}

export default new SubReasonService();
